import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Tooltip} from "primereact/tooltip";
import {Button} from "primereact/button";
import {Tag} from "primereact/tag";
import {Dialog} from "primereact/dialog";
import axios from "axios";
import {Badge} from "primereact/badge";


const CreditHistory = props => {
    const toast = useRef(null);
    const [loadingState, setLoadingState] = useState(false);
    const [histories, setHistories] = useState([]);
    const credit_approver_role = localStorage.getItem("credit_approver") ? true : false;
    const [credit, setCredit] = useState(null);
    const [expandedRows, setExpandedRows] = useState([]);


    useEffect(() => {
        getHistories();
    }, []);

    const getHistories = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/credit-all-history/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            showSuccess("Kredi Harcamaları Görüntülendi");
                            setHistories(data.histories);
                        } else {
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const getHistoryBody = (compute_key, compute_name) => {
        const historyBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return historyBody;
    }

    const getHeader = (value) => {
        return (
            <div align="center" style={{wordBreak: 'break-all'}}>{value}</div>
        );
    }

    const calculateCreditTotal = (rowData) => {
        let total_credit = 0;
        histories.map((val) => {
            if (val.username === rowData.username) {
                total_credit += val.credit;
            }
        });
        return total_credit;
    }

    const headerTemplate = (rowData) => {
        return (
            <React.Fragment>
                <img alt={rowData.username} src={rowData.photo} width="32" height="32"
                     style={{verticalAlign: 'middle', borderRadius: '50%'}}/>&nbsp;&nbsp;
                <span className="image-text">{rowData.username}</span>
            </React.Fragment>
        );
    }

    const footerTemplate = (rowData) => {
        return (
            <React.Fragment>
                <td colSpan="5" style={{textAlign: 'right', fontWeight: 'bold'}}>Toplam Harcanan Kredi</td>
                <td>{calculateCreditTotal(rowData)}</td>
            </React.Fragment>
        );
    }

    if (credit_approver_role) {
        return (
            <div className='p-fluid'>
                <Toast ref={toast}/>
                <Spinner loadingState={loadingState}/>
                <div className="p-grid">
                </div>
                <div className="datatable-responsive-demo">
                    <div className='card'>
                        <DataTable
                            value={histories}
                            className='p-datatable-responsive-demo'
                            rowGroupMode="subheader"
                            groupField="username"
                            expandableRowGroups expandedRows={expandedRows}
                            onRowToggle={(e) => setExpandedRows(e.data)}
                            rowGroupHeaderTemplate={headerTemplate}
                            rowGroupFooterTemplate={footerTemplate}
                            header="KREDİ HARCAMALARI"
                            emptyMessage="Kayıt Bulunamadı"
                        >
                            <Column field="username"
                                    header="Kullanıcı"
                                    body={getHistoryBody("username", "Kullanıcı")}
                                    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    filter
                                    filterPlaceholder="Kullanıcı Adı"
                            />
                            <Column field="history_type"
                                    header="Harcama Türü"
                                    body={getHistoryBody("history_type", "Harcama Türü")}
                                    style={{textAlign: 'center', width: '5.5em'}}
                                    filter
                                    filterPlaceholder="Harcama Türü"
                            />
                            <Column field="history_time"
                                    header="Harcama Zamanı"
                                    body={getHistoryBody("history_time", "Harcama Zamanı")}
                                    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    filter
                                    filterPlaceholder="Harcama Zamanı"
                            />
                            <Column field="detail"
                                    header="Harcama Açıklaması"
                                    body={getHistoryBody("detail", "Harcama Açıklaması")}
                                    style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                            />
                            <Column field="server"
                                    header="Harcama Yapılan Sunucu"
                                    body={getHistoryBody("server", "Harcama Yapılan Sunucu")}
                                    style={{textAlign: 'center', width: '5.5em'}}
                                    filter
                                    filterPlaceholder="Harcama Yapılan Sunucu"
                            />
                            <Column field="credit"
                                    header="Harcanan Kredi"
                                    body={getHistoryBody("credit", "Harcanan Kredi")}
                                    style={{textAlign: 'center', width: '5.5em'}}
                            />
                        </DataTable>
                    </div>
                </div>

            </div>
        );
    } else {
        return (
            window.location.hash = "/notfound"
        )
    }


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditHistory);



// WEBPACK FOOTER //
// ./src/pages/systemmanagement/CreditHistory.jsx